/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Sub_Overview_Billed_For_Seats_MinInputs */



/**
* | output |
* | --- |
* | "billed for {seats} seats (min. 5)" |
*
* @param {Sub_Overview_Billed_For_Seats_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_billed_for_seats_min = /** @type {((inputs: Sub_Overview_Billed_For_Seats_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Billed_For_Seats_MinInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`abgerechnet für ${i?.seats} Plätze (min. 5)`)
	return /** @type {LocalizedString} */ (`billed for ${i?.seats} seats (min. 5)`)
});